import EnvironmentStatus from "rwb/pages/project/types/enums/environmentStatus";
import ComputeEnvironment from "rwb/types/interfaces/computeEnvironment";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

/** Whether the given workbench has at least one running compute environment. */
export const useHasRunningEnvironment = (workbenchId: number | null): boolean => {
  const { data } = useFetcher<ComputeEnvironment[]>(
    workbenchId ? `${VITE_RWB_API}/environments?project_id=${workbenchId}` : null
  );
  return data?.some((env) => env.status === EnvironmentStatus.RUNNING) ?? false;
};
